import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import IssueRequest from "../../magData/Bus/IssueRequest";
import IssueResponse from "../../magData/Bus/IssueResponse";

function BusIssuePage() {

  return (
    <>

      <Container fluid >
        <Row>
          <Col sm={12} >
            <p className="page-title">Bus Issue Method</p>
          </Col>
          <Col sm={12} >
            <p>EndPoint : https://gdscpapi.parsgds.com/gateway/bus/issue</p>
          </Col>
          <Col sm={12} >
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12} >
            <p>Body Parameters</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>gdsRefrenceID</td>
                  <td>Refrence ID</td>
                  <td>Guid </td>
                  <td><Badge bg="warning" text="dark">
                    Required
                  </Badge></td>
                </tr>
              </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Request Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(IssueRequest, null, 2)}
            </pre>


          </Col>
        </Row>

        {/* Response  */}
        <Row>
          <Col sm={12} >
            <p>Response Information</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>success</td>
                  <td>success</td>
                  <td>boolean </td>
                  <td>None.</td>
                </tr>
                <tr>
                  <td>gdsRefrenceID</td>
                  <td>Refrence ID</td>
                  <td>Guid </td>
                  <td></td>
                </tr>
                <tr>
                  <td>ticketBusRef</td>
                  <td>
                    ticketBusRef
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>token</td>
                  <td>
                    token
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>busId</td>
                  <td>
                    busId
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>totalPrice</td>
                  <td>
                    totalPrice
                  </td>
                  <td>Integer</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>issueCode</td>
                  <td>
                    issueCode
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Response Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(IssueResponse, null, 2)}
            </pre>


          </Col>
        </Row>
      </Container>

    </>
  );
}

export default BusIssuePage;